<template>
  <svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
    <!-- eslint-disable-next-line -->
    <path d="M9.00008 17.3334C4.39758 17.3334 0.666748 13.6026 0.666748 9.00008C0.666748 4.39758 4.39758 0.666748 9.00008 0.666748C13.6026 0.666748 17.3334 4.39758 17.3334 9.00008C17.3334 13.6026 13.6026 17.3334 9.00008 17.3334ZM8.16675 11.5001V13.1667H9.83342V11.5001H8.16675ZM8.16675 4.83342V9.83342H9.83342V4.83342H8.16675Z" fill="#F52922"/>
  </svg>
</template>
